import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { Tranlation} from "../editTranslationsGrid";
import {SheetManager} from "../../../siteManagement/sheetManager";
import React from "react";
export default class EditDokumentCategory extends React.Component<EditDokumentCategoryProps, any>{
    private _common = new AppHelper();
    private _translations: {};

    constructor(props) {
        super(props);
        this._common.init(this);
        this._translations = this._getMetaData("translations");
        this.props.context.translations = this._translations;
        this._setEvents();
    }

    private _getMetaData = (name: string) => {
        const objects = this.props.metadata.additional.objects;
        for (let i = 0; i < objects.length; i++) {
            if (objects[i].name == name) {
                return objects[i].data;
            }
        }
    }

    private _checkEntity = () => {
        let result: boolean = false;
        const translations = this.props.entity.Translations;
        for (let i = 0; i < translations.length; i++) {
            if (!Helper.isNullOrEmpty(translations[i].Value)) {
                result = true;
                break;
            }
        }
        if (!result) {
            NotificationHelper.showErrorMessage(this._translations["WebSMS.GeneralSettings.Documents.AtLeastOneName"]);
        }
        return result;
    }

    save = (closeAfterSave) => {
        if (this._common.validate() && this._checkEntity()) {
            let url = "DocumentsSettings/SaveCategory";
            HTTPService.post<JsonResultClass<DocumentCategory>>(url, { model: this.props.entity }).then(result => {
                if (result.Code == 0) {
                    this.props.entity.IsNew = false;
                    Helper.updateEntity(this.props.entity, result.Data);
                    // this.props.entity.Name = result.AdditionalData.NewName;
                    NotificationHelper.showSuccessMessage(result.Message);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                this._common.handlePostSave(result.Code === 0, closeAfterSave);
                this.setState({}, () =>{
                    General.Sheet.Manager.getTopMostSheet().trigger(SheetEventType.Custom, { event: "ReloadRights" });
                });
            });

        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit) {
            this._common.handleFieldChange(field, value, dataItem);
        }
    }

    private _setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "translationsGridChanged") {
                this._common.setEntityDirtyState(true);     
            }
        });
    }

    render() {
        const props = $.extend({}, this.props, this._common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface EditDokumentCategoryProps extends AppBaseProps {
    entity: DocumentCategory;
    context: DokumentCategoryContext;
}

interface DokumentCategoryContext extends Context {
    translations?: {};
}

export interface DocumentCategory extends Entity{
    Id: number;
    Name: string;
    IsRowId: number;
    InternalPlant: boolean;
    IsDeleteable: boolean;
    StorageMode: number;
    DirName: string;
    Translations: any[];
}